import type { Optional } from '@festina-life/core'
import { Select } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'
import { SimpleModal } from '@festina-life/ui/structure'
import { useState } from 'react'

type Props = {
  options: string[]
  value: Optional<string>
  onChange: (nextValue: Optional<string>) => void
  isOpen: boolean
  onClose: () => void
  title: string
}

export const TemplateReferenceChangeModal = ({
  options,
  value,
  onChange,
  isOpen,
  onClose,
  title,
}: Props) => {
  const translate = useTranslate()
  const [currentReference, setCurrentReference] = useState(value)

  const handleChangeTemplateParent = () => {
    onChange(currentReference)
    onClose()
  }

  return (
    <SimpleModal
      title={title}
      closeConfiguration={{ onClose, label: translate('cancel') }}
      acceptConfiguration={{
        onAccept: handleChangeTemplateParent,
        label: translate('save'),
      }}
      isOpen={isOpen}
      className="min-w-fit"
    >
      <Select
        options={options}
        onChange={(nextValue) => setCurrentReference(nextValue)}
        value={currentReference}
        placeholder={translate('none')}
        wrapperProps={{
          label: translate(
            'templateViewer.templateVersionDetails.templateReferenceModal.select.label',
          ),
          description: translate(
            'templateViewer.templateVersionDetails.templateReferenceModal.select.description',
          ),
          className: 'max-w-md',
        }}
      />
    </SimpleModal>
  )
}
